module.exports = __webpack_public_path__ + "img/f9b7d2f396634addad4826586c804696-1440.b5a3f517.jpg";